import { Loader2 } from "lucide-react";
import { motion } from "framer-motion";

export function LoadingFallback() {
  return (
    <motion.div 
      className="flex items-center justify-center min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.15, duration: 0.2 }}
    >
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </motion.div>
  );
}

// Invisible fallback - pages load instantly with prefetching
export function PageLoadingFallback() {
  return <div className="min-h-[50vh]" aria-hidden="true" />;
}
